import { MtUser, MtGroup, MtProjectGroup } from "server/models"
import {
    AccountPermissionsSectioned,
    ProjectPermissionsSectioned,
} from "client/store/utils"
import {
    UserFilters,
    GroupFilters,
    ProjectGroupFilters,
} from "client/store"
import { OrderType } from "client/utils"

export interface AccountPermissionsProps {
    accountId?: number
    hash?: string
}

export interface AccountPermissionsState {
    accountPermissions: AccountPermissionsSectioned
    baseProjectPermissions: ProjectPermissionsSectioned

    users: {
        userIds: readonly number[]
        sortColumn: keyof MtUser
        sortOrder: OrderType
        filters: UserFilters
        selected: readonly number[]
    }
    groups: {
        groupIds: readonly number[]
        sortColumn: keyof MtGroup
        sortOrder: OrderType
        filters: GroupFilters
        selected: readonly number[]
    }
    projectGroups: {
        groupIds: readonly number[]
        sortColumn: keyof MtProjectGroup
        sortOrder: OrderType
        filters: ProjectGroupFilters
        selected: readonly number[]
    }

    reloadList: boolean
}

export const SET_ACCOUNT_PERMISSIONS = "SET_ACCOUNT_PERMISSIONS"

export const UPDATE_ACCOUNT_PERMISSION = "UPDATE_ACCOUNT_PERMISSION"
export const TOGGLE_ACCOUNT_PERMISSION_CUSTOMIZABLE = "TOGGLE_ACCOUNT_PERMISSION_CUSTOMIZABLE"

export const UPDATE_BASE_PROJECT_PERMISSION = "UPDATE_BASE_PROJECT_PERMISSION"
export const TOGGLE_BASE_PROJECT_PERMISSION_CUSTOMIZABLE = "TOGGLE_BASE_PROJECT_PERMISSION_CUSTOMIZABLE"

export const ACCOUNT_PERMISSIONS_USER_IDS = "ACCOUNT_PERMISSIONS_USER_IDS"
export const ACCOUNT_PERMISSIONS_USER_SORT = "ACCOUNT_PERMISSIONS_USER_SORT"
export const ACCOUNT_PERMISSIONS_USER_FILTERS = "ACCOUNT_PERMISSIONS_USER_FILTERS"
export const ACCOUNT_PERMISSIONS_USER_SELECTED = "ACCOUNT_PERMISSIONS_USER_SELECTED"

export const ACCOUNT_PERMISSIONS_GROUP_IDS = "ACCOUNT_PERMISSIONS_GROUP_IDS"
export const ACCOUNT_PERMISSIONS_GROUP_SORT = "ACCOUNT_PERMISSIONS_GROUP_SORT"
export const ACCOUNT_PERMISSIONS_GROUP_FILTERS = "ACCOUNT_PERMISSIONS_GROUP_FILTERS"
export const ACCOUNT_PERMISSIONS_GROUP_SELECTED = "ACCOUNT_PERMISSIONS_GROUP_SELECTED"

export const ACCOUNT_PERMISSIONS_PROJECT_GROUP_IDS = "ACCOUNT_PERMISSIONS_PROJECT_GROUP_IDS"
export const ACCOUNT_PERMISSIONS_PROJECT_GROUP_SORT = "ACCOUNT_PERMISSIONS_PROJECT_GROUP_SORT"
export const ACCOUNT_PERMISSIONS_PROJECT_GROUP_FILTERS = "ACCOUNT_PERMISSIONS_PROJECT_GROUP_FILTERS"
export const ACCOUNT_PERMISSIONS_PROJECT_GROUP_SELECTED = "ACCOUNT_PERMISSIONS_PROJECT_GROUP_SELECTED"

export const ACCOUNT_PERMISSIONS_RELOAD_LIST = "ACCOUNT_PERMISSIONS_RELOAD_LIST"
